import { useGlobals } from 'hooks/useGlobals';
import { useCallback } from 'react';
import { mapCountryToLocale } from 'utils/mappers/mapCountryToLocale';

export const useAvailableLocale = () => {
  const { data: globals } = useGlobals();

  const getAvailableLocale = useCallback(
    (countryCode: string | null) => {
      if (!globals?.availableCountries) return false;

      if (countryCode) {
        const country = globals.availableCountries.find(
          (item) => item.isoCode === countryCode,
        );

        if (country) {
          return mapCountryToLocale(country);
        }

        return null;
      }

      return null;
    },
    [globals?.availableCountries],
  );

  return { getAvailableLocale };
};
